import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrgEndUsers } from '../../actions/org';
import Select from '../../common/Form/Select';
import { useFormContext } from 'react-hook-form';
import { actualValueForDropdown, debounce } from '../../utils/common';
import Input from '../../common/Form/Input';
import { CLEAR_ORG_END_USERS_DROPDOWN_LIST_DATA } from '../../types/org';
import { TicketAgentRole } from '../../pages/Ticket/TicketController';


const Enduser = ({ name, label, onChange = () => { }, org_id, className, required = false, add_new = false, prefill = [], cleanup = true }) => {
    const methods = useFormContext();
    const dispatch = useDispatch();
    const orgEndUsersDropdown = useSelector((state) => state.org.orgEndUsersDropdown);
    const isOrgEndUsersLoading = useSelector((state) => state.loading.isOrgEndUsersLoading);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    let showAddNewEndUserOption = add_new;
    if (newLoggedUserData.org.id === 'org_2wjcBEg5Y2rrFdp1hjpNMTqqmB7') {
        showAddNewEndUserOption = newLoggedUserData.user.roles.some((role) => ['OWNER'].includes(role.label.toUpperCase()));
    }


    const memoizedOrgEndUsers = useMemo(() => {
        let endusers = [];
        if (orgEndUsersDropdown?.[org_id]) {
            endusers = [...orgEndUsersDropdown[org_id]];
        }
        if (showAddNewEndUserOption) {
            endusers = [{ label: 'Add New Enduser', value: 'add-new-enduser' }, ...endusers];
        }
        return endusers;
    }, [orgEndUsersDropdown, org_id, showAddNewEndUserOption]);

    const getEnduserList = ({ limit = 100, page = 1, query = '', org_id }) => {
        dispatch(getOrgEndUsers({ limit, page, query, orgId: org_id, dropdown: true }));
    };

    const debouncedEnduserSearchSearch = useCallback(debounce(getEnduserList), []);

    useEffect(() => {
        if (org_id) {
            getEnduserList({ limit: 100, page: 1, query: '', org_id });
            methods.setValue(name, null);
        }
    }, [org_id]);

    useEffect(() => {
        if (cleanup) {
            return () => {
                dispatch({ type: CLEAR_ORG_END_USERS_DROPDOWN_LIST_DATA });
            }
        }
    }, [dispatch, cleanup]);


    useEffect(() => {
        if (prefill && prefill.length > 0 && memoizedOrgEndUsers && memoizedOrgEndUsers.length > 0) {
            const find = memoizedOrgEndUsers.find((option) => prefill.includes(option.id));
            if (find) {
                methods.setValue(name, find);
            }
        }
    }, [prefill, memoizedOrgEndUsers]);


    const isAddNew = add_new && actualValueForDropdown(methods.watch(name)) === 'add-new-enduser';

    return <>
        <Select
            name={name}
            label={label}
            options={memoizedOrgEndUsers}
            isLoading={isOrgEndUsersLoading}
            required={required}
            className={className}
            shouldUnregister
            onInputChange={(event) => {
                if (event.length > 0) {
                    debouncedEnduserSearchSearch({ query: event, org_id })
                }
            }}
            onChange={(event) => {
                const value = event?.value;
                onChange(value)
            }}
        />
        {isAddNew && <Input className={className} required={required} name={`${name}:new`} label={`${label}`} />}
    </>
}

export default Enduser;
